import { type ProjectCode } from '@constants'
import { useApiCampaignAddonProducts } from '@hooks-api/fortune-fastpass/useApiCampaignAddonProducts'
import { type AllProduct, type AllProductWithMetadata, type Group } from '@hooks-api/types/dataModel/products'
import { useMemo } from 'react'

function flattenAllProducts(allProductWithMetadata?: AllProductWithMetadata[]) {
  return allProductWithMetadata?.flatMap(data => data.all_product) ?? []
}

// TODO: Add testing
export function parseAddonProducts(allProducts: AllProduct[] = []) {
  const allProductMap: Record<number, AllProduct> = {}
  let addonProducts: (Group & { allProductId: AllProduct['id'] })[] = []
  allProducts.forEach((allProduct) => {
    allProductMap[allProduct.id] = allProduct
    const groupsWithAllProductId = allProduct.group.map(group => ({ ...group, allProductId: allProduct.id }))
    addonProducts = [...addonProducts, ...groupsWithAllProductId]
  })
  return {
    allProductMap,
    addonProducts,
  }
}

interface CampaignAddonProductsArgs {
  code?: string
  projectCode?: ProjectCode
}

export const useCampaignAddonProducts = ({ code, projectCode }: CampaignAddonProductsArgs) => {
  const { destructuredData: addonProductsWithMetadata, isLoading } = useApiCampaignAddonProducts({ code })

  const allProducts = useMemo(() =>
    projectCode
      ? flattenAllProducts(addonProductsWithMetadata?.[projectCode])
      : [],
  [addonProductsWithMetadata, projectCode])

  const allProjectProducts = useMemo(() =>
    Object.values(addonProductsWithMetadata ?? {})
      .flatMap(items => items.flatMap(item => item.all_product)),
  [addonProductsWithMetadata])

  const { allProductMap, addonProducts } = useMemo(() => parseAddonProducts(allProducts), [allProducts])

  const { allProductMap: allProjectProductMap, addonProducts: allProjectAddonProducts } = useMemo(() => parseAddonProducts(allProjectProducts), [allProjectProducts])

  return {
    allProductMap,
    addonProducts,
    allProjectProductMap,
    allProjectAddonProducts,
    isLoading,
  }
}
